<template>
  <v-app>
    <v-app-bar
      app
      height="100"
    >
      <v-avatar
        class="mr-3"
        color="grey lighten-5"
        size="70"
      >
        <v-img
          contain
          max-height="100%"
          :src="nacho"
        ></v-img>
      </v-avatar>

      <v-toolbar-title class="font-weight-black headline">
        Ignacio Hernández 🍍 - iOS Developer - Content Creator
      </v-toolbar-title>
    </v-app-bar>

    <v-content>
      <section id="hero">
        <v-row no-gutters>
          <v-img :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'" :src="myImage" 
          >
            <v-theme-provider dark>
              <v-container fill-height>
                <v-row
                  align="center"
                  class="white--text mx-auto"
                  justify="center"
                >
                  <v-col
                    class="white--text text-center"
                    cols="12"
                    tag="h1"
                  >
                  </v-col>
                  <br>
                  <br>
                  <br>
                  <br>
                  <v-btn
                    class="align-self-end"
                    fab
                    outlined
                    @click="$vuetify.goTo('#about-me')"
                  >
                    <v-icon>mdi-chevron-double-down</v-icon>
                  </v-btn>
                </v-row>
              </v-container>
            </v-theme-provider>
          </v-img>
        </v-row>
      </section>

      <section id="about-me">
        <div class="py-12"></div>

        <v-container class="text-center">
          <h2 class="display-2 font-weight-bold mb-3">Acerca de mi</h2>

          <v-responsive
            class="mx-auto mb-8"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-responsive
            class="mx-auto title font-weight-light mb-8"
            max-width="720"
          >
          Soy Ignacio Hernández 🍍, iOS Developer y comodín de otros lenguajes y plataformas. 
          Apasionado por nuevas tecnologías y emprendedurismo.
          Adoro los retos y me encanta aprender algo nuevo todos los días.
          Actualmente trabajo en el equipo de desarrollo de <a href="https://www.overcome.mx/">Overcome</a>
          Me encanta desarrollar aplicaciones para iOS y diseñar sistemas. Me gusta analizar problemas y encontrar la mejor solución.
          </v-responsive>

          <v-avatar
            class="elevation-12 mb-12"
            size="128"
          >
            <v-img :src="nacho"></v-img>
          </v-avatar>

          <div></div>

        </v-container>

        <div class="py-12"></div>
      </section>

      <section
        id="features" class="secondary"
      >
        <div class="py-12"></div>

        <v-container class="text-center">
          <h2 class="display-2 font-weight-bold mb-3">Experiencia</h2>

          <v-responsive
            class="mx-auto mb-12"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-row>
            <v-col
              v-for="({ icon, title, text }, i) in features"
              :key="i"
              cols="12"
              md="4"
            >
              <v-card
                class="py-12 px-4"
                color="primary"
                flat
              >
                <v-theme-provider dark>
                  <div>
                    <v-avatar
                      color="primary"
                      size="88"
                    >
                      <v-icon
                        large
                        v-text="icon"
                      ></v-icon>
                    </v-avatar>
                  </div>
                </v-theme-provider>

                <v-card-title
                  class="justify-center font-weight-black text-uppercase"
                  v-text="title"
                ></v-card-title>

                <v-card-text
                  class="subtitle-1"
                  v-text="text"
                >
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <div class="py-12"></div>
      </section>

      <section id="stats">
        <v-parallax
          :height="$vuetify.breakpoint.smAndDown ? 700 : 500"
          src="https://images.unsplash.com/photo-1510915228340-29c85a43dcfe?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80"
        >
          <v-container fill-height>
            <v-row class="mx-auto">
              <v-col
                v-for="[value, title] of stats"
                :key="title"
                cols="12"
                md="3"
              >
                <div class="text-center">
                  <div
                    class="display-3 font-weight-black mb-4"
                    v-text="value"
                  ></div>

                  <div
                    class="title font-weight-regular text-uppercase"
                    v-text="title"
                  ></div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-parallax>
      </section>

      <section id="blog">
        <div class="py-12"></div>

        <v-container>
          <h2 class="display-2 font-weight-bold mb-3 text-uppercase text-center">Proyectos emprendedores</h2>

          <v-responsive
            class="mx-auto mb-12"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-row>
            <v-col
              v-for="({ src, text, title, linkReference}, i) in articles"
              :key="i"
              cols="12"
              md="4"
            >
              <v-img
                :src="src"
                class="mb-4"
                height="275"
                max-width="100%"
              ></v-img>

              <h3
                class="font-weight-black mb-4 text-uppercase"
                v-text="title"
              ></h3>

              <div
                class="title font-weight-light mb-5"
                v-text="text"
              ></div>

              <v-btn
                class="ml-n4 font-weight-black"
                :href="linkReference"
                link = true
                target = "blank"
              >
                Ir al proyecto
              </v-btn>
            </v-col>
          </v-row>
        </v-container>

        <div class="py-12"></div>
      </section>

      <v-sheet
        id="contact"
        color="#333333"
        dark
        tag="section"
        tile
      >
        <div class="py-12"></div>

        <v-container>
          <h2 class="display-2 font-weight-bold mb-3 text-uppercase text-center">Contáctame</h2>

          <v-responsive
            class="mx-auto mb-12"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>
            <v-divider></v-divider>
          </v-responsive>
          <v-theme-provider dark >
              <h1 class=" text-center">ignacio.hernandez.pina@gmail.com</h1>
          </v-theme-provider>
        </v-container>

        <div class="py-12"></div>
      </v-sheet>
    </v-content>

    <v-footer
      class="justify-center"
      color="#292929"
      height="100"
    >
      <div class="title font-weight-light grey--text text--lighten-1 text-center">
        &copy; {{ (new Date()).getFullYear() }} — ihernandez🍍DEV
      </div>
    </v-footer>
  </v-app>
  </template>
 <script>
  export default {
    el: '#app',
    data () {
      return {
        myImage: require('@/assets/ihernandezbackground.png'),
        nacho: require('@/assets/nacho.jpg'),
        pineapple: require('@/assets/pineapple.png'),
        horasioBanner: require('@/assets/horasioBanner.png'),
        articles: [
          {
            src: require('@/assets/horasioBanner.png'),
            title: 'Horas.io',
            text: 'Horasio nació de la necesidad de tener un administrador de tareas sencillo para un equipo pequeño. El principal objetivo de Horasio es ver al pasado. Está diseñado para equipos que carecen de tiempo para planear situaciones a largo plazo.',
            linkReference: 'https://horas.io'
          },
          {
            src: 'https://images.unsplash.com/photo-1416339442236-8ceb164046f8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1892&q=80',
            title: 'Instructor de iOS',
            text: 'Creador de contenido en español para enseñar a varios nuevos aspirantes como desarrolladores de iOS ',
            linkReference: 'https://horas.io'
          },
        ],
        features: [
          {
            icon: 'mdi-apple',
            title: 'Desarrollador de iOS',
            text: 'El desarrollo de aplicaciones móviles es mi fuerte. Desde 2016 he desarrollado aplicaciones para iOS en Objective C y migrando lentamente a Swift. Teniendo una aplicación en el AppStore "Eleonor" y varias en desarrollo.',
          },
          {
            icon: 'mdi-web',
            title: 'Desarrollo Web',
            text: 'He desarrollado alguna aplicaciones web y rest con javascript de backend. Horas.io sería un ejemplo de ello.',
          },
          {
            icon: 'mdi-cloud',
            title: 'Desarrollo Web con Spring y Google Cloud',
            text: 'Desarrollo de algunos módulos con proyectos ya armados de spring y con la nube de google. Tengo noción del la implementación de spring y las bondades y limitaciones de la nube de google',
          },
          {
            icon: 'mdi-android',
            title: 'Desarrollo de Android',
            text: 'He desarrollado algunos módulos de android, implementando conocimientos básicos del ciclo de vida del activity y la aplicación.',
          },{
            icon: 'mdi-looks',
            title: 'Lenguajes de Programación',
            text: ' Objective C, Swift, Java, C#, Javascript',
          },{
            icon: 'mdi-cube-outline',
            title: 'Servicios de desarrollo y producción',
            text: 'Firebase, GoogleCloud, Git, GitHub',
          },
        ],
        stats: [
          ['Mid-level', 'iOS Developer'],
          ['3', 'Años como desarrollador de iOS'],
          ['1', 'Aplicaciones en tiendas'],
          ['0', 'Videos'],
        ],
      }
    }
  }
</script>